import React from 'react';
import { useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

const DatePicker = ({ id, name, label, placeholder, min, max, className, showError = true, disabled = false }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="relative w-full">
      {label && <label className="input-label">{label}</label>}
      <input
        id={id}
        disabled={disabled}
        type="date"
        min={min}
        max={max}
        name={name}
        placeholder={placeholder}
        className={twMerge(
          `input ${errors[name] && !showError && 'text-contrast1'} cursor-pointer bg-white appearance-none`,
          className,
        )}
        {...register(name, {
          required: {
            value: true,
            message: "Це поле є обов'язковим",
          },
        })}
      />
      {showError && errors[name] && <span className="text-xs text-contrast1 mt-1">{errors[name].message}</span>}
    </div>
  );
};

export default DatePicker;
